import styled from 'styled-components'
import breakpoints from 'styles/breakpoints'

export const Body = styled.div`
  display: flex;
  background-color: var(--color-background);
`
export const Content = styled.div`
  min-height: calc(100vh - 110px);
  width: 100%;
  @media (max-width: ${breakpoints.desktop}) {
    margin-top: 60px;
  }
`
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
  @media (max-width: ${breakpoints.desktop}) {
    width: 100%;
  }
`
export const Footer = styled.footer`
  background-color: var(--color-sidebar);
  height: 50px;
  width: 100%;
`

export const SidebarOverlay = styled.div`
  display: none;
  @media (max-width: ${breakpoints.desktop}) {
    display: block;
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 150;
  }
`
